import { defineMessages } from 'react-intl';

export default defineMessages({
  success: 'Category deleted',
  title: 'Delete Board'
});
